import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';
import { Observable } from 'rxjs';
import { IConetionConfiguration } from '../interfaces/IConetionConfiguration';
import { IReportConfiguration } from '../interfaces/IReportConfiguration';

@Injectable()
export class PowerBIService {
  powerBIUrl = 'api/PowerBI-report';
  constructor(private _powerBIHttp: RestApi) { }

  getPowerBIConfigurations(): Observable<IConetionConfiguration[]> {
    return this._powerBIHttp.get(`${this.powerBIUrl}/report-configuration-list`);
  }

  saveConfig(conexionConfiguration: IConetionConfiguration): Observable<any> {
    return this._powerBIHttp.post(`${this.powerBIUrl}/conexion-configuration`, conexionConfiguration);
  }

  saveEnvironment(environmentConfiguration: IReportConfiguration): Observable<any> {
    return this._powerBIHttp.post(`${this.powerBIUrl}/environment`, environmentConfiguration);
  }
}
